// generated from 95 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceBrowserFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_browser_filter"),
  comparison_key: z.enum([
    "1",
    "10", // 48 (50.53%)
    "27", // 16 (16.84%)
    "11", // 14 (14.74%)
    "12", // 5 (5.26%)
    "17", // 4 (4.21%)
    "25", // 4 (4.21%)
    "2", // 2 (2.11%)
    "28", // 2 (2.11%)
  ]),
  display_name: z.string(),
  // undefined: 17 (17.89%), defined 78 (82.11%)
  raw_value: z.union([z.string(), z.array(z.string())]).optional(),
  value: z.union([z.string(), z.array(z.string())]),
  varies_by_app_group: z.literal(false),
});
